import { DatePicker, Modal } from 'antd';
import React from 'react';
import { Dayjs } from 'dayjs';

export interface Props {
  isOpen: boolean;
  onDateSelect: (date: Dayjs | null) => void;
  onCancel: () => void;
}

const DatePickerModal = ({ isOpen, onDateSelect, onCancel }: Props) => (
  <Modal
    destroyOnClose
    data-testid="date-picker-modal"
    footer={null}
    onCancel={onCancel}
    open={isOpen}
    title="Select a Date"
  >
    <DatePicker
      open
      getPopupContainer={() => document.body}
      onChange={onDateSelect}
      placeholder="Select date"
      style={{ width: '100%' }}
    />
  </Modal>
);

export default DatePickerModal;

